// removed by extract-text-webpack-plugin
module.exports = {"item-dropdown":"MoreOptions__item-dropdown___3OlEp"};